import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseFloatingLabel",
  props: {
    labelState: {
      type: String,
      "default": function _default() {
        return "inline-label";
      }
    },
    isValid: {
      type: Boolean,
      "default": function _default() {
        return null;
      }
    },
    labelText: {
      type: String,
      required: true
    },
    disabled: {
      type: [String, Boolean],
      "default": false
    }
  },
  emits: ["click"]
});